import { Box, Link as MUILink } from "@mui/material";
import { Link } from "react-router-dom";
import { ROUTES } from "@/utils/navigation";
import { linkStyles } from "./styles";

const ShoppingCartLinks = () => {
  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column", md: "row" }}
      gap={{ xs: 1, md: 2 }}
      mt={{ xs: 1, md: 0 }}
    >
      <MUILink
        component={Link}
        to={`${ROUTES.solutions}`}
        color="text.accent"
        sx={linkStyles}
      >
        Continue Shopping
      </MUILink>
    </Box>
  );
};

export default ShoppingCartLinks;
